import css from './equipmentFilterStatus.module.css'
import equipmentFilterStatusConstants from './equipmentFilterStatus.constans'
import MultiDropdown from 'src/shared/Inputs/MultiDropdownInput'
import { IEquipment } from '@/pages/Equipment/equipment.types'

interface IProps {
  statuses: Array<IEquipment['state']>
  onChange: (statutes: IEquipment['state'][], name: string) => void
  name?: string
}

const EquipmentFilterStatus = (props: IProps) => {
  return (
    <div className={css.wrapper}>
      <MultiDropdown
        name={props.name}
        selectedOptions={props.statuses as Array<string>}
        title="Статус"
        options={equipmentFilterStatusConstants.fieldTypeOptions}
        type="filter"
        panelStyle={{ width: '230px' }}
        onSelect={props.onChange}
      />
    </div>
  )
}

export default EquipmentFilterStatus
